import React from 'react';
import { Button, useTheme } from '@mui/material';

interface CustomButtonProps {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
}

export const CustomButton: React.FC<CustomButtonProps> = ({ 
  onClick, 
  text, 
  disabled = false,
  fullWidth = false,
  size = 'medium',
  startIcon,
  endIcon
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      size={size}
      sx={{
        backgroundColor: theme.palette.button.default,
        color: 'white',
        borderRadius: 2,
        padding: '10px 16px',
        textTransform: 'none',
        width: fullWidth ? '100%' : 'auto',
        '&:hover': {
          backgroundColor: theme.palette.info.dark,
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
        }
      }}
    >
      {text}
    </Button>
  );
};
